module.exports = __webpack_public_path__ + "static/character-55d6fd8a7f0eba7f677433da52a99174.png";